import { useRef, useState } from 'react'

import { PktTabItem, PktTabs, PktTextinput } from '@/components'
import { PktButton } from '@/components/button/Button'
import { PktCheckbox } from '@/components/checkbox/Checkbox'
import { PktHeader, Representing, User, UserMenuItem } from '@/components/header/Header'
import { PktLink } from '@/components/link/Link'
import { PktModal } from '@/components/modal/Modal'

export default function Header() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const [isDarkMode, setIsDarkMode] = useState(false)
  const [openedMenu, setOpenedMenu] = useState<'none' | 'slot' | 'search' | 'user'>('none')

  function logOut() {
    console.log('Logger ut')
  }

  function changeRepresentation() {
    console.log('Bytter representasjon')
  }

  function userMenuItemFunction() {
    console.log('Mine adresser')
  }

  function logoClick() {
    console.log('Logoklikk')
  }

  const user: User = {
    name: 'Aksel Web Opdahl',
    lastLoggedIn: new Date(),
  }

  const representing: Representing = {
    name: 'Joe & the Juice Norge AS',
    orgNumber: '911738066',
  }

  const userMenu: UserMenuItem[] = [
    {
      title: 'Mine bookinger',
      iconName: 'heart',
      target: '#',
    },
    {
      title: 'Mine adresser',
      iconName: 'house-heart',
      target: userMenuItemFunction,
    },
    {
      title: 'Innstillinger',
      iconName: 'cogwheel',
      target: '#',
    },
  ]

  function handleSearch(query: string) {
    console.log('Søker etter:', query)
    // Example: router.push(`/search?q=${query}`)
  }

  return (
    <>
      <PktHeader
        data-mode={isDarkMode ? 'dark' : undefined}
        canChangeRepresentation={true}
        changeRepresentation={changeRepresentation}
        representing={representing}
        user={user}
        userMenu={userMenu}
        logOutButtonPlacement="userMenu"
        logOut={logOut}
        serviceName="Gravferdsetaten"
        logoClick={logoClick}
        showSearch={true}
        onSearch={handleSearch}
        searchPlaceholder="Søk i tjenester..."
        mobileBreakpoint={1000}
        tabletBreakpoint={2000}
        slotMenuVariant="icon-right"
        slotMenuText="Navigasjon"
        openedMenu={openedMenu}
      >
        <PktLink href="#">Hjem</PktLink>
        <PktLink href="#">Tjenester</PktLink>
        <PktLink href="#">Om oss</PktLink>
        <PktButton skin="secondary" onClick={() => console.log('Kontakt klikket')}>
          Kontakt oss
        </PktButton>
      </PktHeader>
      <main className="page-main pkt-container pkt-container--full">
        <section className="component">
          <h1>Header full</h1>
          <div style={{ marginBottom: '2rem' }}>
            <h2>Z-index test</h2>
            <PktTextinput
              id="searchInput"
              label="Søk"
              placeholder="Søk i tjenester..."
              onChange={(e) => console.log('Endret søketekst:', e.target.value)}
            />
            <PktTabs>
              <PktTabItem>tab 1</PktTabItem>
              <PktTabItem>tab 2</PktTabItem>
              <PktTabItem>tab 3</PktTabItem>
            </PktTabs>
            <PktButton skin="primary" onClick={() => modalRef.current?.showModal()}>
              Åpne modal
            </PktButton>
            <PktModal headingText="Test modal for z-index" closeOnBackdropClick size="medium" ref={modalRef}>
              <p>Denne modalen skal vises over headeren.</p>
              <p>Test at backdrop og modal-innhold er over fixed header.</p>
            </PktModal>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>Header settings</h2>
            <PktCheckbox
              isSwitch
              id="darkModeToggle"
              label="Dark mode"
              checked={isDarkMode}
              onChange={() => setIsDarkMode(!isDarkMode)}
            />
            <h3>Open user menu</h3>
            <PktButton skin="secondary" onClick={() => setOpenedMenu(openedMenu === 'user' ? 'none' : 'user')}>
              Toggle user menu
            </PktButton>
            <h3>Open main menu</h3>
            <PktButton skin="secondary" onClick={() => setOpenedMenu(openedMenu === 'slot' ? 'none' : 'slot')}>
              Toggle main menu
            </PktButton>
          </div>
          <p>
            Robin tally gordon al penguin selina zeus charlatan todd. Fox nyssa riddler pit, amanda a. Young boomerang
            outsider tim anarky, montoya damian cobblepot amanda kobra mad ivy gearhead. Deadshot hammer montoya vale
            thomas martha joker batarang raatko batman green. Catwoman amanda oracle, joe calendar. Spectre montoya
            shiva catwoman al shrike! Jim joker pennyworth batarang doom, atomic rhino cluemaster pit katana firefly
            society jason? Chill, grayson crane red temblor birds. Lex spoiler face montoya! Joker, hood red chimera
            arrow! Boomerang birds mugsy phantom ghul swamp strange? Shrike scorn wing shade freeze gordon red owl kyle,
            calendar harley alfred scorn. Mugsy league snake nocturna raatko helena calendar blue. Ghul ra, poison
            beetle scorn! Damian damian batarang spectre! Deadshot bat gleeson robin two, bruce collector blake
            elongated. Fairchild young lynx master lillian rhino cypher barbara night shiva blink checkmate. Atomic
            tumbler deadshot cluemaster hangman fairchild shadow jason anarky quinn. Clench scarecrow chill moth gotham
            shadow copperhead sinestro? Copperhead flash falcone arkham drake; gearhead boomerang! Bane clayface canary
            ventriloquist martha batarang harley snake a maxie gordon! Azrael maxie lantern mask gordon jester jester.
          </p>
          <p>
            Blink rupert spectre night abattoir red lazarus deadshot ivy caird strange blake. Montoya elongated blink
            spoiler collector face gearhead a calendar society temblor. Clock gearhead selina echo toymaker creeper
            night master atkins fairchild? Doom harley todd jester hangman knight temblor bat atomic chimera. Bruce
            basil ragdoll young cain ghul. Joe face nyssa alcor rumor flash fright ghul. Ragman raatko arrow outsider
            phantom atomic metallo chill hatter deadshot carmine smoke. Solomon deathstroke barbara thomas, tally knight
            luthor bruce maroni superman mask ragman. Batgirl montoya league atom. Ragdoll oswald outsider temblor hugo
            cluemaster scarecrow temblor cluemaster mask clock vale joker! Nocturna lillian ali ivy nigma fairchild
            carmine martha prey zucco! Lucius diamond alfred cluemaster aquaman shade a elongated aiko caird of.
            Outsider caird hush selina black ivy oracle martha shiva. Bullock bartok ghul luthor batgirl black atom
            luthor abbott. Nyssa.
          </p>
          <p>
            Lazarus shadow amanda charlatan maxie faith damian. Copperhead ivy hush crane, hangman atom. Two bartok,
            birds arrow hush edward kane nigma shadow harlequin hood deadshot. Prey tumbler deadshot fright ra strange.
            Doom aquaman lazarus batmobile ventriloquist gordon killer wing nyssa bennett. Knight hood dent azrael,
            alcor spectre green. Batman maxie, rumor lucius. Manor dent jester batmobile maxie selina green green
            gearhead. Birds bartok rose barbara shiva harlequin black. Tumbler huntress outsider gleeson barrow face
            tumbler temblor quinn dick wing. Jim beetle blake blue abdullah martha phantom fright supergirl league.
            Batman master deathstroke barbara.
          </p>
          <p>
            Abbott diamond joe rupert superman chimera abbott wayne jester snake killer luthor! Elongated, abdullah
            nocturna bartok. Sinestro ghul bartok copperhead hood. Chase abattoir mask fox jim ragdoll scarecrow joe
            collector czonk! Hush atom falcone green boomerang. Catwoman, checkmate a zucco swamp ra harley canary
            master elongated arrow killer joker. Cain faith, joker ali quinn spectre deadshot chill vale ra batgirl
            czonk. Fairchild amanda temblor fairchild damian gargoyle harvey mask luthor night penguin. Maxie, aiko
            firefly bat gearhead clock cain. Mister canary huntress diamond lazarus, cluemaster league shade kobra
            league mask joker outsider. Batarang abbott hangman, ventriloquist gargoyle. Harley spoiler dick kobra
            oswald lex chase vicki. Black penguin harvey pennyworth moth. Doom vale jason nigma gordon gargoyle
            batmobile charlatan creeper beetle falcone young freeze. Hood atomic mugsy penguin. Alfred fairchild
            firefly, oracle harlequin oswald raatko mugsy faith flash drake batmobile. Hatter cluemaster batcave croc
            clock. Temblor temblor mugsy moth pennyworth fright shrike gotham carmine. Batmobile hush clock phantom.
            Harvey luthor bullock fairchild nyssa bat caird bat chimera basil vicki. Knight hugo barbara copperhead
            snake shade owl joker montoya gleeson ventriloquist? Boomerang hood shade carmine. Abattoir blue shiva vicki
            fairchild of sinestro cain, chase red fox jason kane.
          </p>
          <p>
            Arkham robin mad jason alcor cobblepot harvey lynx crane creeper hangman. Face robin of harvey, firefly
            ragman. Echo mask canary doom pennyworth creeper czonk joe wing caird. Robin smoke toymaker abbott strange
            creeper sinestro tim tally. Shiva atomic martha grey gordon zeus batmobile barrow bullock joe basil. Chase
            superman phantom jester harvey harlequin. Arrow oswald chimera boomerang, nyssa face temblor green faith.
            Diamond spoiler kyle basil young rose clench faith faith harlequin oswald bartok. Ali basil nigma aquaman of
            helena black harley zatanna aquaman zatanna canary lynx? Joe arkham aquaman abbott arkham clayface cain
            harley firefly solomon damian poison. Charlatan atkins young, ventriloquist ragdoll calendar bat grayson. Al
            croc wing penguin thomas lucius spectre. Tim shade the gargoyle grayson selina blink boomerang. Gearhead
            croc firefly, tim luthor freeze pit mask anarky poison. Cluemaster freeze gearhead outsider. Lex fairchild,
            harley atomic. Cain scarecrow aquaman moth gleeson! Collector, jason?
          </p>
          <p>
            Poison justice, batgirl firefly. Harley, hatter batarang hammer ventriloquist echo lazarus. Snake edward
            boomerang zucco rose atkins shrike snake harley martha riddler black. Arkham blink shrike manor mugsy, wing
            master hush falcone! Boomerang, elongated batarang montoya. Kyle mister edward doom kane luthor swamp thorne
            arkham batman. Nocturna clock diamond metallo ventriloquist! Metallo luthor batman abattoir hugo pit wayne
            arrow fox hatter nyssa mister. Azrael lazarus dent.
          </p>
          <p>
            Harvey lillian phantom basil zatanna caird justice owl crane carmine. The moth faith drake blake atomic
            young master robin. Bat pit of rupert. Pit raatko al rupert scorn society kane aquaman mask justice katana
            ali mugsy. Amanda bruce prey lynx abattoir hangman snake rose collector harlequin hammer. Lucius red shrike
            alfred smoke harlequin batcave clayface calendar. Shrike riddler jason faith gearhead ali elongated drake
            oracle canary ragman. Dick chill supergirl vicki. Nigma atom martha ventriloquist calendar hush atkins
            aquaman hush spectre. Caird firebug blink spectre the abdullah echo fox pit. Echo bullock czonk bruce oracle
            sinestro cluemaster snake harley manor crane creeper thomas. Harley hood beetle bennett swamp poison al
            thorne phantom. Rose tally katana face, gordon green? Carmine lucius bullock.
          </p>
          <p>
            The dick gotham red rose calendar. The freeze lucius abdullah todd zatanna chimera prey black thorne a
            riddler birds. Shade edward faith fox batmobile flash deathstroke caird. America owl todd night clayface joe
            falcone. Gotham helena clayface zatanna abattoir, hush kyle knight gearhead quinn oracle. Knight, basil
            shadow todd beetle. Barrow fright harvey abdullah kane black temblor bartok face. Cain collector society
            hammer gleeson. Katana clench al hangman zucco oracle todd selina ragdoll mugsy huntress strange. Lucius lex
            harvey maroni jester calendar manor, ivy ra todd lynx lantern shade. Chimera zeus ventriloquist copperhead
            carmine gleeson face raatko shade vicki firefly atom. Wayne hammer, maxie gleeson. Poison shade owl dent
            katana tally. Catwoman boomerang kobra mask hush riddler firefly shrike abdullah lucius doom cain. Arrow
            rupert fright thomas oswald!
          </p>
          <p>
            Clayface tally creeper red face batarang strange batarang owl aiko tally society zeus. Toymaker hush arkham
            maroni alcor young spoiler vicki bruce jim amanda hugo anarky. Canary rupert firebug hatter flash rumor
            spoiler batgirl cypher edward. Black mister manor vicki. Joker society, tim batman joe firebug shade canary.
            Drake bullock beetle snake temblor scorn scarecrow, charlatan gordon arkham clayface. Batgirl fright
            copperhead bennett zeus clock doom arkham killer bat ragdoll zeus. Jim falcone of rumor penguin black.
            Maroni harvey damian, spoiler hangman raatko firebug catwoman. Czonk anarky dick charlatan amanda bat shadow
            smoke zucco killer cypher ali. Jason maroni spectre grey gargoyle justice. Tumbler, ra penguin deadshot
            ragman batarang america mad! Fox cluemaster spoiler mister? Kane katana anarky croc atkins batcave catwoman
            penguin cypher harlequin two deathstroke. Mad atom spoiler.
          </p>
          <p>
            Creeper nocturna rhino vicki croc fairchild shadow a. Martha robin gearhead ragdoll diamond helena strange
            firebug grayson calendar lex. Fairchild charlatan ra pennyworth america joe clayface night chill fairchild
            thomas phantom maroni. Alcor bennett jason wayne knight aquaman cobblepot? Dent shade atkins grey spoiler
            cypher luthor diamond. Gargoyle temblor lantern ivy snake abbott wayne czonk cain joe ali. Oswald, harley
            bartok birds caird basil hush. Caird ghul faith ragdoll harlequin alcor. The alcor flash thomas lynx thomas
            elongated freeze. Deadshot cypher superman fright atkins pennyworth zucco! Croc alcor metallo quinn america
            chimera batman fairchild mugsy al vale anarky! Nocturna hood abattoir faith gleeson canary canary damian
            charlatan harvey killer bennett clock! Outsider, kobra jester flash deathstroke fairchild superman. Lynx
            blink lex alfred. Barbara damian abbott poison bane. Kyle pit pit dick prey echo nyssa mad todd? Rupert
            alcor hood scorn edward rupert echo deadshot abbott drake batmobile oswald. Nocturna faith boomerang
            copperhead cobblepot tim ra! Hugo ragman, ragman croc alcor bartok azrael tim snake. Atomic hugo, rupert
            barbara shiva. Outsider helena young rupert aquaman black barrow. Chase manor oracle beetle helena supergirl
            scorn oswald creeper todd mister nigma. Batcave grundy alcor atom nigma luthor lex charlatan.
          </p>
        </section>
      </main>
    </>
  )
}
